import {ReportData} from "../../../reports/report.data";
import {collection, field} from "@fedeltapointofsale/data-client";
import {EmployeeReportSelectionData} from "../../../employee/employee/controls/employee-report-selection-control.component";
import {SellableReportSelectionData} from "../../../catalogue/sellable/controls/sellable-report-selection-control.component";
import {MemberReportSelectionData} from "../../member/controls/member-report-selection-control.component";
import {MembershipTypeReportSelectionData} from "../../membership-type/controls/membership-type-report-selection-control.component";

export class MemberLoyaltyReportData extends ReportData<MemberLoyaltyReportData> {
    @field reportType: string = "PRODUCT";
    @field loyaltyType: string = "ACCRUAL";
    @field summary: boolean = true;
    @field topOrderBy: boolean = false;
    @field topLimitStmt: string;

    @collection() groupBy: string[] = ["none"];
    @collection(EmployeeReportSelectionData) employees: EmployeeReportSelectionData[];
    @collection(SellableReportSelectionData) sellables: SellableReportSelectionData[];
    @collection(MemberReportSelectionData) members: MemberReportSelectionData[];
    @collection(MembershipTypeReportSelectionData) membershipType: MembershipTypeReportSelectionData[];
}
